// see https://www.coditty.com/code/angular-6-interceptor-response-example

import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { GlobalsService } from "./globals.service";

@Injectable({ providedIn: "root" })
export class InterceptService implements HttpInterceptor {
  public constructor(
    private router: Router,
    private globalsService: GlobalsService,
  ) {}

  // intercept request and add token
  public intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const isUpload = request.url.includes("file");
    const isJWTLogin = request.url.includes("loginjwt");

    if (isUpload) {
      request = request.clone({
        url: `${this.globalsService.getApiUrl()}${request.url}`,
        setHeaders: {
          System: this.globalsService.getSystem(),
          UserName: this.globalsService.getOwnerName(),
          Authorization: `key ${this.globalsService.getOwnerKey()}`,
        },
      });
    } else if (isJWTLogin) {
      request = request.clone({
        url: `${this.globalsService.getApiUrl()}${request.url}`,
        setHeaders: {
          System: this.globalsService.getSystem(),
          UserName: this.globalsService.getOwnerName(),
          Authorization: `Bearer ${this.globalsService.getJWT()}`,
        },
      });
    } else if (
      !(request.url.startsWith("http") || this.isValidAssetRequest(request))
    ) {
      request = request.clone({
        url: `${this.globalsService.getApiUrl()}${request.url}`,
        setHeaders: {
          "Content-Type": "application/json; charset=utf-8",
          System: this.globalsService.getSystem(),
          UserName: this.globalsService.getOwnerName(),
          Authorization: `key ${this.globalsService.getOwnerKey()}`,
        },
      });
    } else if (request.url.startsWith("http")) {
      request = request.clone({
        setHeaders: {
          System: this.globalsService.getSystem(),
          UserName: this.globalsService.getOwnerName(),
          Authorization: `key ${this.globalsService.getOwnerKey()}`,
        },
      });
    }

    return next.handle(request).pipe(
      tap(
        (event) => {
          if (event instanceof HttpResponse) {
            // this.globalsService.log(' all looks good');
            // http response status code
            // this.globalsService.log(event.status);
          }
        },
        (error) => {
          //fluent validation routes will return 400 on validation errors
          if (error.status === 400 && request.url.endsWith("/validate")) {
            return;
          }

          this.globalsService.log("----intercept.service error response----");

          // console.error('status code:');
          // console.error(error.status);
          // console.error(error.message);

          if (error.status === 403) {
            // forbidden
            this.globalsService.log(
              `Code 403 returned from API for ${request.url}`,
            );
            this.globalsService.logoutUI();
            this.router.navigateByUrl(`/`);
          } else if (error.status === 401) {
            // authenticated but expired
            this.globalsService.loadExpiryHtml(error.error);
            this.globalsService.handleWarning("Unauthorized", null, false);
          } else {
            const source = "InterceptService";

            // handleError will try to log error again, so
            // do not call handleError on logging error.
            if (
              error.message &&
              error.message.indexOf("/api/logging/error") > -1
            ) {
              this.globalsService.log("Logging error.");
            } else {
              this.globalsService.handleError(error, source);
            }
          }
        },
      ),
    );
  }

  // TODO: JCD some sort of token?
  private isValidAssetRequest(request: HttpRequest<any>): boolean {
    return request.url == "./data/app-config.json";
  }
}
